module.exports = __webpack_public_path__ + "images/f9761d6c64cfc8c696d91b78a91eb04e.svg";